<gryf-navbar *ngIf="!isGalleryOpen" class="bg-success"></gryf-navbar>
<div class="bg-primary">
  <router-outlet class="bg-primary"></router-outlet>
</div>
<gryf-footer *ngIf="!isGalleryOpen"></gryf-footer>
<gryf-cookies *ngIf="showCookiesInfoPanel && !isGalleryOpen"></gryf-cookies>
